import "core-js/modules/es6.reflect.construct.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-animate.
* homepage: https://github.com/react-component/animate
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { toArrayChildren, mergeChildren, findShownChildInChildrenByKey, findChildInChildrenByKey, isSameChildren } from './ChildrenUtils';
import AnimateChild from './AnimateChild';
var defaultKey = "u_animate_".concat(Date.now());
import animUtil from './util';

function getChildrenFromProps(props) {
  var children = props.children;

  if ( /*#__PURE__*/React.isValidElement(children)) {
    if (!children.key) {
      return /*#__PURE__*/React.cloneElement(children, {
        key: defaultKey
      });
    }
  }

  return children;
}

function noop() {}

var propTypes = {
  component: PropTypes.any,
  animation: PropTypes.object,
  transitionName: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  transitionEnter: PropTypes.bool,
  transitionAppear: PropTypes.bool,
  exclusive: PropTypes.bool,
  transitionLeave: PropTypes.bool,
  onEnd: PropTypes.func,
  onEnter: PropTypes.func,
  onLeave: PropTypes.func,
  onAppear: PropTypes.func,
  showProp: PropTypes.string
};
var defaultProps = {
  animation: {},
  component: 'span',
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var Animate = /*#__PURE__*/function (_Component) {
  _inherits(Animate, _Component);

  var _super = _createSuper(Animate);

  function Animate(props) {
    var _this;

    _classCallCheck(this, Animate);

    _this = _super.call(this, props);
    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];
    _this.state = {
      children: toArrayChildren(getChildrenFromProps(_this.props))
    };
    _this.performEnter = _this.performEnter.bind(_assertThisInitialized(_this));
    _this.performAppear = _this.performAppear.bind(_assertThisInitialized(_this));
    _this.handleDoneAdding = _this.handleDoneAdding.bind(_assertThisInitialized(_this));
    _this.performLeave = _this.performLeave.bind(_assertThisInitialized(_this));
    _this.performLeave = _this.performLeave.bind(_assertThisInitialized(_this));
    _this.handleDoneLeaving = _this.handleDoneLeaving.bind(_assertThisInitialized(_this));
    _this.isValidChildByKey = _this.isValidChildByKey.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Animate, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;
      var showProp = this.props.showProp;
      var children = this.state.children;

      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }

      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = toArrayChildren(getChildrenFromProps(nextProps));
      var props = this.props; // exclusive needs immediate response

      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }

      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys; // last props children if exclusive

      var currentChildren = props.exclusive ? toArrayChildren(getChildrenFromProps(props)) : this.state.children; // in case destroy in showProp mode

      var newChildren = [];

      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && findChildInChildrenByKey(nextChildren, currentChild.key);
          var newChild;

          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = /*#__PURE__*/React.cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
          } else {
            newChild = nextChild;
          }

          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !findChildInChildrenByKey(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = mergeChildren(currentChildren, nextChildren);
      } // need render to avoid update


      this.setState({
        children: newChildren
      });
      nextChildren.forEach(function (child) {
        var key = child && child.key;

        if (child && currentlyAnimatingKeys[key]) {
          return;
        }

        var hasPrev = child && findChildInChildrenByKey(currentChildren, key);

        if (showProp) {
          var showInNext = child.props[showProp];

          if (hasPrev) {
            var showInNow = findShownChildInChildrenByKey(currentChildren, key, showProp);

            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });
      currentChildren.forEach(function (child) {
        var key = child && child.key;

        if (child && currentlyAnimatingKeys[key]) {
          return;
        }

        var hasNext = child && findChildInChildrenByKey(nextChildren, key);

        if (showProp) {
          var showInNow = child.props[showProp];

          if (hasNext) {
            var showInNext = findShownChildInChildrenByKey(nextChildren, key, showProp);

            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: "performEnter",
    value: function performEnter(key) {
      // may already remove by exclusive
      if (this[key]) {
        this.currentlyAnimatingKeys[key] = true;
        this[key].componentWillEnter(this.handleDoneAdding.bind(this, key, 'enter'));
      }
    }
  }, {
    key: "performAppear",
    value: function performAppear(key) {
      if (this[key]) {
        this.currentlyAnimatingKeys[key] = true;
        this[key].componentWillAppear(this.handleDoneAdding.bind(this, key, 'appear'));
      }
    }
  }, {
    key: "handleDoneAdding",
    value: function handleDoneAdding(key, type) {
      var props = this.props;
      delete this.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

      if (props.exclusive && props !== this.nextProps) {
        return;
      }

      var currentChildren = toArrayChildren(getChildrenFromProps(props));

      if (!this.isValidChildByKey(currentChildren, key)) {
        // exclusive will not need this
        this.performLeave(key);
      } else {
        if (type === 'appear') {
          if (animUtil.allowAppearCallback(props)) {
            props.onAppear(key);
            props.onEnd(key, true);
          }
        } else {
          if (animUtil.allowEnterCallback(props)) {
            props.onEnter(key);
            props.onEnd(key, true);
          }
        }
      }
    }
  }, {
    key: "performLeave",
    value: function performLeave(key) {
      // may already remove by exclusive
      if (this[key]) {
        this.currentlyAnimatingKeys[key] = true;
        this[key].componentWillLeave(this.handleDoneLeaving.bind(this, key));
      }
    }
  }, {
    key: "handleDoneLeaving",
    value: function handleDoneLeaving(key) {
      var props = this.props;
      delete this.currentlyAnimatingKeys[key]; // if update on exclusive mode, skip check

      if (props.exclusive && props !== this.nextProps) {
        return;
      }

      var currentChildren = toArrayChildren(getChildrenFromProps(props)); // in case state change is too fast

      if (this.isValidChildByKey(currentChildren, key)) {
        this.performEnter(key);
      } else {
        var end = function end() {
          if (animUtil.allowLeaveCallback(props)) {
            props.onLeave(key);
            props.onEnd(key, false);
          }
        };
        /* eslint react/no-is-mounted:0 */


        if (this.mounted && !isSameChildren(this.state.children, currentChildren, props.showProp)) {
          this.setState({
            children: currentChildren
          }, end);
        } else {
          end();
        }
      }
    }
  }, {
    key: "isValidChildByKey",
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;

      if (showProp) {
        return findShownChildInChildrenByKey(currentChildren, key, showProp);
      }

      return findChildInChildrenByKey(currentChildren, key);
    }
  }, {
    key: "stop",
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this[key];

      if (component) {
        component.stop();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;

      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }

          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }

          return /*#__PURE__*/React.createElement(AnimateChild, {
            key: child.key,
            ref: function ref(_ref) {
              return _this4[child.key] = _ref;
            },
            animation: props.animation,
            transitionName: props.transitionName,
            transitionEnter: props.transitionEnter,
            transitionAppear: props.transitionAppear,
            transitionLeave: props.transitionLeave
          }, child);
        });
      }

      var Component = props.component;

      if (Component) {
        var passedProps = props;

        if (typeof Component === 'string') {
          passedProps = {
            className: props.className,
            style: props.style
          };
        }

        return /*#__PURE__*/React.createElement(Component, passedProps, children);
      }

      return children[0] || null;
    }
  }]);

  return Animate;
}(Component);

;
Animate.defaultProps = defaultProps;
Animate.propTypes = propTypes;
export default Animate;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-animate/src/Animate.js